import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import ReportWidget from './ReportWidget';
import FlickityWidget from './FlickityWidget';
import LoadingPage from '../LoadingPage';
import Chart from '../../util/chart';

class SSR11Widget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isReady: false,
    };

    const startdate = moment().subtract(90, 'days').format('MM-DD-YYYY');
    const enddate = moment().format('MM-DD-YYYY');
    this.reportOptions = ['X', '', startdate, enddate, 'A', 'N'];
    this.handleData = this.handleData.bind(this);
  }

  getData1(data) {
    const ret = {};
    const final = [];
    const fields = ['elapsday', 'startdays', 'downdays'];
    data.forEach(v => {
      const tmp = v.Initials.toUpperCase();
      if (ret[tmp]) {
        fields.forEach(f => {
          ret[tmp][f] += parseFloat(v[f]);
        });
      } else {
        ret[tmp] = {};
        fields.forEach(f => {
          ret[tmp][f] = parseFloat(v[f]);
        });
      }
    });

    _.forEach(ret, (v, k) => {
      const tmp = {};
      tmp.category = k;
      fields.forEach(f => {
        tmp[f] = v[f];
      });
      final.push(tmp);
    });

    return final;
  }

  getGraphs1() {
    const ret = [];
    const fields = {
      elapsday: 'Elapsed Days',
      startdays: 'Start Days',
      downdays: 'Down Days',
    };
    _.forEach(fields, (v, k) => {
      ret.push(
        Chart.getLineGraph({
          balloonText: "<span style='font-size:14px'><b>[[title]]</b> [[category]]<br>[[value]]</span>",
          id: k,
          title: v,
          valueField: k,
          urlField: 'url',
        })
      );
    });
    return ret;
  }

  getData2(data) {
    const ret = {};
    const final = [];

    data.forEach(v => {
      if (v.Initials !== 'ALL') {
        if (!ret[v.Initials]) {
          ret[v.Initials] = 0;
        }
        ret[v.Initials] += parseFloat(v.elapsday);
      }
    });

    const keysSorted = Object.keys(ret).sort((a, b) => {
      return ret[b] - ret[a];
    });

    const maxSlices = 5;

    let len;
    let other = 0;
    if (keysSorted.length >= maxSlices - 1) {
      len = maxSlices;
      for (let i = maxSlices; i < keysSorted.length; i++) {
        other += ret[keysSorted[i]];
      }
    } else {
      len = keysSorted.length;
    }

    for (let i = 0; i < len; i++) {
      final.push({
        label: keysSorted[i],
        value: ret[keysSorted[i]],
      });
    }
    if (other) {
      final.push({
        label: 'Other',
        value: other,
      });
    }

    return final;
  }

  handleData({ data, cols }) {
    // transform array of positional data to array of json objects
    data.forEach((row, i) => {
      const obj = {};
      row.forEach((col, j) => {
        if (cols[j]) {
          obj[cols[j].name] = col;
        }
      });
      data[i] = obj;
    });

    this.setState(
      {
        data1: this.getData1(data),
        graphs1: this.getGraphs1(data),
        data2: this.getData2(data),
        isReady: true,
      },
      this.renderCharts
    );
  }

  renderCharts() {
    Chart.makeSerialChart('ssr11-widget-chart-1', {
      valueAxes: [
        {
          title: 'Days',
        },
      ],
      dataProvider: this.state.data1,
      graphs: this.state.graphs1,
      legend: {
        align: 'center',
        markerType: 'circle',
      },
    });

    Chart.makePieChart('ssr11-widget-chart-2', {
      dataProvider: this.state.data2,
      balloonText: "<span style='font-size:14px'>[[title]]<br><b>[[value]]</b> ([[percents]])</span>",
    });
  }

  render() {
    return (
      <ReportWidget pageName="SSR11" reportOptions={this.reportOptions} handleData={this.handleData}>
        {this.state.isReady ? (
          <FlickityWidget>
            <div id="ssr11-widget-chart-2" className="carousel-cell" />
            <div id="ssr11-widget-chart-1" className="carousel-cell" />
          </FlickityWidget>
        ) : (
          <LoadingPage />
        )}
      </ReportWidget>
    );
  }
}

export default SSR11Widget;
